import { FC, useRef } from 'react'
import { ActiveArea, Dot } from './styled'

type Props = {
  char: string
  chapter: string
  ActiveAreaComponent?: typeof ActiveArea
}

export const Sound: FC<Props> = ({
  char,
  chapter,
  ActiveAreaComponent = ActiveArea,
}) => {
  const audioRef = useRef<HTMLAudioElement>(null)

  return (
    <ActiveAreaComponent
      data-char={char}
      onMouseEnter={() => audioRef.current?.play()}
      onClick={() => audioRef.current?.play()}
    >
      <Dot />
      <audio
        ref={audioRef}
        src={`${process.env.PUBLIC_URL}/assets/${chapter}/alphabet/${encodeURI(
          char
        )}.mp3`}
        preload="auto"
      />
    </ActiveAreaComponent>
  )
}
